/* ===========================================================
   PRASINOUS - Charm Engraving

   One card per SHAPE in the grid. One side or both is chosen in the
   panel, which swaps the variant in the slot. The second variant gets
   a hidden twin card so the builder can draw and price it.

   Photo mode applies to the FRONT face only.

   Done sits under the text lines, where the thumb already is. On a
   phone the keyboard's return key reads Next while more lines are
   open, Done on the last one, and pressing it closes the panel.
   Edit lives in the header and only shows while collapsed.

   This module owns ADD TO CART for every charm design. Each line
   carries a _Design fingerprint: the same design added twice merges
   to quantity 2, two different designs never merge into each other.

   Every DOM write is compared first, so the observer never chases
   its own tail.

   Config: assets/cp-engraving-positions.js
   =========================================================== */
(function () {
  'use strict';

  var SHAPES = window.CP_ENGRAVE_SHAPES || {};
  var ITEMS  = window.CP_ENGRAVE_ITEMS || {};
  var FONTS  = window.CP_ENGRAVE_FONTS || [];
  var GEOM   = window.CP_ENGRAVE_GEOMETRY || {};
  var COPY   = window.CP_ENGRAVE_COPY || {};

  var PROP_PREFIX = 'Personalization';

  function setText(el, t) { if (el) { var v = String(t == null ? '' : t); if (el.textContent !== v) el.textContent = v; } }
  function setHtml(el, h) { if (el && el.innerHTML !== h) el.innerHTML = h; }
  function setHidden(el, on) { if (el && el.hidden !== !!on) el.hidden = !!on; }
  function setAttrIfNew(el, n, v) { if (el && el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function setClass(el, c, on) { if (el && el.classList.contains(c) !== !!on) el.classList.toggle(c, !!on); }
  function setDisabled(el, on) {
    if (!el || el.hasAttribute('disabled') === !!on) return;
    if (on) el.setAttribute('disabled', 'disabled'); else el.removeAttribute('disabled');
  }

  (function injectCss() {
    if (document.getElementById('cpe-style')) return;
    var s = document.createElement('style');
    s.id = 'cpe-style';
    s.textContent = [
      '.cpe.is-collapsed .cpe__top, .cpe.is-collapsed .cpe__cols, .cpe.is-collapsed .cpe__photo,',
      '.cpe.is-collapsed .cpe__notes, .cpe.is-collapsed .cpe__tune, .cpe.is-collapsed .cpe__actions{ display:none !important; }',
      '.cpe.is-collapsed .cpe__head{ margin-bottom:0; padding-bottom:0; border-bottom:0; }',
      '.cpe__summary{ flex:1 1 auto; min-width:0; margin-left:8px;',
      '  font-size:11px; color:rgba(37,32,88,.7); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }',
      '.cpe__summary[hidden]{ display:none !important; }',
      '.cpe__actions{ display:flex; justify-content:flex-end; margin-top:12px; }',
      '.cpeDoneBtn{ flex:0 0 auto; margin-left:8px; padding:9px 18px; min-width:84px;',
      '  border:1px solid #F5A623; border-radius:999px; background:#F5A623; color:#143362;',
      '  font-size:12px; font-weight:700; line-height:1; cursor:pointer;',
      '  -webkit-tap-highlight-color:transparent; touch-action:manipulation; }',
      '.cpeDoneBtn--edit{ padding:6px 12px; min-width:58px; font-size:11px; background:#fff; }',
      '.cpeDoneBtn[hidden]{ display:none !important; }',
      '.cpeDoneBtn:focus-visible{ outline:2px solid rgba(37,32,88,.35); outline-offset:2px; }',
      '@media (hover:hover) and (pointer:fine){ .cpeDoneBtn:hover{ box-shadow:0 4px 12px rgba(0,0,0,.12); } }'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  })();

  function itemFor(id) { return ITEMS[String(id)] || null; }
  function shapeFor(k) { return SHAPES[k] || null; }
  function fontFor(key) {
    for (var i = 0; i < FONTS.length; i++) if (FONTS[i].key === key) return FONTS[i];
    return FONTS[0] || { key: 'classic', label: 'Classic', family: 'sans-serif', weight: 600 };
  }
  function fontIndex(key) { for (var i = 0; i < FONTS.length; i++) if (FONTS[i].key === key) return i; return 0; }
  function geoFor(shapeKey, sizeKey) {
    var out = {};
    [GEOM.default || {}, (GEOM.bySize || {})[sizeKey] || {}, (GEOM.byShape || {})[shapeKey] || {}]
      .forEach(function (src) { Object.keys(src).forEach(function (k) { out[k] = src[k]; }); });
    return out;
  }
  function normalizeSizeKey(raw) {
    var s = String(raw || 'medium').toLowerCase().trim();
    if (s === 'xlarge' || s === 'morelarge') return 'morelarge';
    if (s === 'large' || s === 'small' || s === 'xsmall') return s;
    return 'medium';
  }
  function clean(v) { return String(v == null ? '' : v).trim(); }
  function nonEmpty(a) { return (a || []).map(clean).filter(function (t) { return t !== ''; }); }
  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function designHash(str) { var h = 0; for (var i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0; return Math.abs(h).toString(36); }

  var reflowTimer = null;
  function reflow() {
    if (reflowTimer) clearTimeout(reflowTimer);
    reflowTimer = setTimeout(function () {
      reflowTimer = null;
      try { window.dispatchEvent(new Event('resize')); window.dispatchEvent(new Event('scroll')); } catch (e) {}
    }, 40);
  }

  var productCache = {};
  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
    return productCache[handle];
  }
  var variantInfo = {};
  function primeShapes(onReady) {
    Promise.all(Object.keys(SHAPES).map(function (key) {
      var s = SHAPES[key];
      if (!s.handle) return Promise.resolve();
      return loadProduct(s.handle).then(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) { variantInfo[String(v.id)] = { price: v.price, available: !!v.available, title: p.title }; });
      });
    })).then(function () { if (onReady) onReady(); });
  }

  var fontsReady = (function () {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all(FONTS.map(function (f) {
      return document.fonts.load((f.weight || 600) + ' 40px ' + f.family).catch(function () {});
    })).then(function () { return document.fonts.ready; }).catch(function () {});
  })();
  fontsReady.then(reflow);

  var imgCache = {};
  function loadImage(src) {
    if (imgCache[src]) return imgCache[src];
    imgCache[src] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); };
      im.onerror = function () { reject(new Error('load failed')); };
      im.src = src;
    });
    return imgCache[src];
  }

  var tileCache = {};
  function drawTile(o) {
    var key = [o.src, o.font, o.rot, o.photo ? 'P' : 'T', (o.lines || []).join('\u0001'), JSON.stringify(o.geo)].join('|');
    if (tileCache[key]) return tileCache[key];
    tileCache[key] = Promise.all([loadImage(o.src), fontsReady]).then(function (res) {
      var im = res[0];
      var W = im.naturalWidth || 600, H = im.naturalHeight || 600;
      var longest = Math.max(W, H) || 600;
      var scale = longest < 640 ? (640 / longest) : Math.min(1, 900 / longest);
      var cw = Math.round(W * scale), ch = Math.round(H * scale);
      var cv = document.createElement('canvas');
      cv.width = cw; cv.height = ch;
      var ctx = cv.getContext('2d');
      ctx.drawImage(im, 0, 0, cw, ch);
      var g = o.geo || {};
      var lines = o.photo ? [String(COPY.photoTile || 'PHOTO')] : nonEmpty(o.lines);
      if (lines.length) {
        var boxW = cw * ((g.w == null ? 46 : g.w) / 100);
        var cx = cw * ((g.cx == null ? 50 : g.cx) / 100);
        var cy = ch * ((g.cy == null ? 58 : g.cy) / 100);
        var f = fontFor(o.font), weight = f.weight || 600;
        var ladder = g.lineScale || [0.30, 0.24, 0.19];
        var size = boxW * (ladder[Math.min(lines.length, 3) - 1] || 0.2);
        ctx.save();
        ctx.translate(cx, cy);
        if (o.rot) ctx.rotate(-o.rot * Math.PI / 180);
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = g.color || '#4a3f35';
        for (var guard = 0; guard < 80; guard++) {
          ctx.font = weight + ' ' + size + 'px ' + f.family;
          var widest = 0;
          for (var i = 0; i < lines.length; i++) widest = Math.max(widest, ctx.measureText(lines[i]).width);
          if (widest <= boxW || size < 6) break;
          size *= 0.94;
        }
        ctx.font = weight + ' ' + size + 'px ' + f.family;
        var gap = size * (g.lineGap == null ? 1.18 : g.lineGap);
        var startY = -((lines.length - 1) / 2) * gap;
        for (var j = 0; j < lines.length; j++) ctx.fillText(lines[j], 0, startY + j * gap);
        ctx.restore();
      }
      try { return cv.toDataURL('image/png'); } catch (e) { return null; }
    }).catch(function () { return null; });
    return tileCache[key];
  }

  var FIELD_KEYS = ['f1', 'f2', 'f3', 'b1', 'b2', 'b3'];
  function escField(s) { return clean(s).replace(/_/g, '_u').replace(/\*/g, '_s'); }
  function unescField(s) { return String(s || '').replace(/_([us])/g, function (m, c) { return c === 'u' ? '_' : '*'; }); }
  function encodeState(s) {
    var photo = s.type === 'photo';
    var out = [(photo ? 'p' : 't') + fontIndex(s.font)];
    var values = (s.front || []).slice(0, 3).concat((s.back || []).slice(0, 3));
    for (var i = 0; i < 6; i++) { if (photo && i < 3) continue; var v = escField(values[i]); if (v !== '') out.push(FIELD_KEYS[i] + v); }
    return out.join('*');
  }
  function decodeState(raw) {
    var str = String(raw || ''); if (!str) return null;
    if (/^eyJ/.test(str)) { try { var b64 = str.replace(/-/g, '+').replace(/_/g, '/'); while (b64.length % 4) b64 += '='; return JSON.parse(decodeURIComponent(escape(atob(b64)))); } catch (e) { return null; } }
    var parts = str.split('*');
    var head = parts.shift() || 't0';
    var type = head.charAt(0) === 'p' ? 'photo' : 'text';
    var fi = parseInt(head.slice(1), 10);
    var font = (FONTS[isFinite(fi) && fi >= 0 ? fi : 0] || FONTS[0] || {}).key;
    var values = ['', '', '', '', '', ''];
    var keyed = parts.length > 0 && parts.every(function (p) { return FIELD_KEYS.indexOf(p.slice(0, 2)) > -1; });
    if (keyed) parts.forEach(function (p) { var i = FIELD_KEYS.indexOf(p.slice(0, 2)); if (i > -1) values[i] = unescField(p.slice(2)); });
    else parts.forEach(function (p, i) { if (i < 6) values[i] = unescField(p); });
    return { t: type, f: font, a: values.slice(0, 3), b: values.slice(3, 6) };
  }

  var instances = [];

  function initRoot(root) {
    if (!root || root.dataset.cpeInit === '1') return;
    var panel = root.querySelector('[data-cpe-panel]');
    if (!panel) return;
    root.dataset.cpeInit = '1';

    var st = { type: 'text', font: (FONTS[0] || {}).key || 'classic', side: 'front', front: ['', '', ''], back: ['', '', ''] };
    var shown = { front: 1, back: 1 };
    var syncing = false, lastUrlValue = null, collapsed = false, lastActiveId = 0;

    var ghosts     = root.querySelector('[data-cpe-ghosts]');
    var head       = panel.querySelector('.cpe__head');
    var elName     = panel.querySelector('[data-cpe-name]');
    var elPrice    = panel.querySelector('[data-cpe-price]');
    var elFaces    = panel.querySelector('[data-cpe-faces]');
    var elSides    = panel.querySelector('[data-cpe-sides]');
    var elPreview  = panel.querySelector('[data-cpe-preview]');
    var elFont     = panel.querySelector('[data-cpe-font]');
    var elFontWrap = panel.querySelector('[data-cpe-fontwrap]');
    var elCols     = panel.querySelector('[data-cpe-textfields]');
    var colFront   = panel.querySelector('[data-cpe-col="front"]');
    var colBack    = panel.querySelector('[data-cpe-col="back"]');
    var headFront  = panel.querySelector('[data-cpe-head-front]');
    var headBack   = panel.querySelector('[data-cpe-head-back]');
    var elPhotoWrap= panel.querySelector('[data-cpe-photofields]');
    var elNotes    = panel.querySelector('.cpe__notes');

    /* header: summary + Edit (collapsed only). bottom: Done. */
    var elSummary = document.createElement('span');
    elSummary.className = 'cpe__summary';
    elSummary.hidden = true;
    var editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'cpeDoneBtn cpeDoneBtn--edit';
    editBtn.setAttribute('data-cpe-done', '1');
    editBtn.textContent = 'Edit';
    editBtn.hidden = true;
    if (head) {
      if (elName && elName.nextSibling) head.insertBefore(elSummary, elName.nextSibling); else head.appendChild(elSummary);
      head.appendChild(editBtn);
    }
    var actions = document.createElement('div');
    actions.className = 'cpe__actions';
    var doneBtn = document.createElement('button');
    doneBtn.type = 'button';
    doneBtn.className = 'cpeDoneBtn';
    doneBtn.setAttribute('data-cpe-done', '1');
    doneBtn.textContent = 'Done';
    actions.appendChild(doneBtn);
    if (elNotes && elNotes.parentElement) elNotes.parentElement.insertBefore(actions, elNotes);
    else panel.querySelector('.cpe__box').appendChild(actions);

    setText(panel.querySelector('[data-cpe-charnote]'), COPY.charNote || '');
    setText(panel.querySelector('[data-cpe-final]'), COPY.finalSale || '');
    setText(panel.querySelector('[data-cpe-photohead]'), COPY.photoHeadline || '');
    setText(panel.querySelector('[data-cpe-photobody]'), COPY.photoBody || '');
    setText(panel.querySelector('[data-cpe-label-text]'), COPY.typeText || 'Text');
    setText(panel.querySelector('[data-cpe-label-photo]'), COPY.typePhoto || 'Photo');
    setText(panel.querySelector('[data-cpe-label-font]'), COPY.fontLabel || 'Font');
    panel.querySelectorAll('[data-cpe-side]').forEach(function (b) { setText(b, b.getAttribute('data-cpe-side') === 'back' ? (COPY.backTab || 'Back') : (COPY.frontTab || 'Front')); });
    setText(headFront, COPY.frontTab || 'Front');
    setText(headBack, COPY.backTab || 'Back');

    if (elFont && !elFont.options.length) {
      FONTS.forEach(function (f) { var op = document.createElement('option'); op.value = f.key; op.textContent = f.label; op.style.fontFamily = f.family; elFont.appendChild(op); });
      elFont.value = st.font;
    }
    var maxChars = (GEOM.default && GEOM.default.maxChars) || 14;
    panel.querySelectorAll('[data-cpe-line]').forEach(function (i) {
      setAttrIfNew(i, 'maxlength', String(maxChars));
      setAttrIfNew(i, 'autocapitalize', 'words');
      setAttrIfNew(i, 'enterkeyhint', 'done');
    });

    function slots() {
      var el = root.querySelector('[data-charm-variant-ids]');
      return String(el && el.value || '').split(',').map(function (x) { var n = Number(String(x).trim()); return isFinite(n) ? n : 0; });
    }
    function activeEngrave() {
      var s = slots();
      for (var i = 0; i < s.length; i++) { var it = itemFor(s[i]); if (it) return { id: s[i], slotIndex: i, item: it }; }
      return null;
    }
    function btnFor(id) { return root.querySelector('[data-charm-item][data-variant-id="' + id + '"]'); }

    function ensureTwin(shapeKey, wantId) {
      if (!wantId || btnFor(wantId) || !ghosts) return btnFor(wantId);
      var sh = shapeFor(shapeKey); if (!sh) return null;
      var source = btnFor(sh.one) || btnFor(sh.both); if (!source) return null;
      var twin = source.cloneNode(true);
      twin.setAttribute('data-variant-id', String(wantId));
      twin.setAttribute('data-cpe-twin', '1');
      twin.removeAttribute('data-cpq-sig'); twin.removeAttribute('data-cpq-gone');
      twin.classList.remove('is-selected', 'is-locked', 'is-armed');
      var info = variantInfo[String(wantId)];
      if (info) { twin.setAttribute('data-price-cents', String(info.price)); var p = twin.querySelector('.cp__price'); if (p) p.textContent = money(info.price); }
      var bar = twin.querySelector('.cpqBar'); if (bar) bar.remove();
      var badge = twin.querySelector('.cpqSlots'); if (badge) badge.remove();
      ghosts.appendChild(twin);
      return twin;
    }

    function placementMode() {
      var el = root.querySelector('input[name="cpPlacement-' + (root.dataset.cpBlockId || '') + '"]:checked');
      return el ? el.value : 'standard';
    }
    function geoCurrent(a) { var b = btnFor(a.id); return geoFor(a.item.shape, normalizeSizeKey(b && b.dataset.cpSize)); }
    function rotFor(a) {
      var g = geoCurrent(a); if (g.upright === false) return 0;
      var profiles = window.CP_POS_PROFILES || {};
      var prof = profiles[(root.dataset.cpProfile || 'default').trim()] || profiles.default || {};
      var maps = (placementMode() === 'tight' ? prof.tight : prof.standard) || {};
      var b = btnFor(a.id);
      var map = maps[normalizeSizeKey(b && b.dataset.cpSize)] || maps.medium || {};
      var pos = map[a.slotIndex + 1]; var r = pos && Number(pos.r);
      return isFinite(r) ? r : 0;
    }
    function placePanel(a) {
      var b = btnFor(a.id);
      if (!b || b.hasAttribute('data-cpe-twin')) { var sh = shapeFor(a.item.shape); b = sh ? btnFor(sh.one) : null; }
      if (!b) return;
      var host = b.closest('.cpCollections__content') || b.parentElement;
      if (!host || panel.parentElement === host) return;
      host.appendChild(panel); reflow();
    }

    function switchFaces(want) {
      var a = activeEngrave(); if (!a) return;
      var sh = shapeFor(a.item.shape); if (!sh) return;
      var targetId = want === 2 ? sh.both : sh.one;
      if (!targetId || String(targetId) === String(a.id)) return;
      var info = variantInfo[String(targetId)]; if (info && info.available === false) return;
      ensureTwin(a.item.shape, targetId);
      var api = root.cpApi; if (!api) return;
      var s = slots(); s[a.slotIndex] = Number(targetId);
      api.writeSelected(s, api.rebuildTitles ? api.rebuildTitles(s) : []);
      if (want === 1) { st.side = 'front'; st.back = ['', '', '']; shown.back = 1; panel.querySelectorAll('[data-cpe-line^="back-"]').forEach(function (i) { if (i.value !== '') i.value = ''; }); }
      lastActiveId = Number(targetId);
      sync();
    }
    function paintFaces(a) {
      var sh = shapeFor(a.item.shape); var hasBoth = !!(sh && sh.both);
      setHidden(elFaces, !hasBoth); if (!hasBoth || !elFaces) return;
      elFaces.querySelectorAll('[data-cpe-face]').forEach(function (b) {
        var n = Number(b.getAttribute('data-cpe-face'));
        var info = variantInfo[String(n === 2 ? sh.both : sh.one)];
        var label = n === 2 ? (COPY.bothSides || 'Both sides') : (COPY.oneSide || 'One side');
        setHtml(b, label + (info ? '<small>' + money(info.price) + '</small>' : ''));
        setClass(b, 'is-active', n === a.item.sides);
        setDisabled(b, !!(info && info.available === false));
      });
    }

    function rowFor(side, idx) { var i = panel.querySelector('[data-cpe-line="' + side + '-' + idx + '"]'); return i ? i.closest('.cpe__row') : null; }
    function revealFromValues(side) {
      var arr = side === 'back' ? st.back : st.front, last = 0;
      for (var i = 0; i < 3; i++) if (clean(arr[i]) !== '') last = i + 1;
      shown[side] = Math.max(shown[side], last, 1);
    }
    function syncRows() {
      ['front', 'back'].forEach(function (side) {
        for (var i = 0; i < 3; i++) {
          setHidden(rowFor(side, i), i >= shown[side]);
          var inp = panel.querySelector('[data-cpe-line="' + side + '-' + i + '"]');
          setAttrIfNew(inp, 'enterkeyhint', (i + 1 < shown[side]) ? 'next' : 'done');
        }
        setHidden(panel.querySelector('[data-cpe-addline="' + side + '"]'), shown[side] >= 3);
      });
    }

    function patchAll() {
      var a = activeEngrave(); if (!a) return;
      var b = btnFor(a.id); if (!b || !b.dataset.image) return;
      var src = b.dataset.image, geo = geoCurrent(a), photo = st.type === 'photo';
      drawTile({ src: src, lines: st.front, font: st.font, geo: geo, rot: rotFor(a), photo: photo }).then(function (url) {
        if (!url) return;
        document.querySelectorAll('img.cpGalleryOverlay__charm[data-cp-variant-id="' + a.id + '"]').forEach(function (im) { setAttrIfNew(im, 'src', url); });
      });
      drawTile({ src: src, lines: st.front, font: st.font, geo: geo, rot: 0, photo: photo }).then(function (url) {
        if (url) setAttrIfNew(root.querySelector('[data-cp-selected-grid] [data-slot-index="' + a.slotIndex + '"] img'), 'src', url);
      });
      var onBack = st.side === 'back';
      drawTile({ src: src, lines: onBack ? st.back : st.front, font: st.font, geo: geo, rot: 0, photo: photo && !onBack }).then(function (url) { if (url) setAttrIfNew(elPreview, 'src', url); });
    }

    function isValid() { var a = activeEngrave(); if (!a || st.type === 'photo') return true; return nonEmpty(st.front).length > 0; }

    function summaryText(a) {
      if (st.type === 'photo') { var back = nonEmpty(st.back).join(' / '); return (COPY.typePhoto || 'Photo') + (back ? ' \u00b7 ' + back : ''); }
      var f = nonEmpty(st.front).join(' / ');
      var bk = a.item.sides === 2 ? nonEmpty(st.back).join(' / ') : '';
      var parts = [fontFor(st.font).label];
      if (f) parts.push(f);
      if (bk) parts.push('\u21c4 ' + bk);
      return parts.join(' \u00b7 ');
    }

    function updateUrl() {
      var value = activeEngrave() ? encodeState(st) : null;
      if (value === lastUrlValue) return;
      lastUrlValue = value;
      try { var u = new URL(window.location.href); if (value) u.searchParams.set('cp_eng', value); else u.searchParams.delete('cp_eng'); window.history.replaceState(null, '', u.toString()); } catch (e) {}
    }

    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        var a = activeEngrave();
        if (panel.hidden !== !a) { panel.hidden = !a; reflow(); }
        if (!a) { lastActiveId = 0; updateUrl(); return; }

        if (Number(a.id) !== lastActiveId) {
          var prev = itemFor(lastActiveId);
          if (!(prev && prev.shape === a.item.shape)) collapsed = false;
          lastActiveId = Number(a.id);
        }

        placePanel(a);
        paintFaces(a);

        var two = a.item.sides === 2, photo = st.type === 'photo';
        var frontEditable = !photo, backEditable = two, anyEditable = frontEditable || backEditable;
        if (!two) { st.side = 'front'; st.back = ['', '', '']; shown.back = 1; panel.querySelectorAll('[data-cpe-line^="back-"]').forEach(function (i) { if (i.value !== '') i.value = ''; }); }

        setHidden(elSides, !two);
        setHidden(colFront, !frontEditable);
        setHidden(colBack, !backEditable);
        setHidden(elCols, !anyEditable);
        setClass(elCols, 'is-single', !(frontEditable && backEditable));
        setHidden(headFront, !(frontEditable && backEditable));
        setHidden(headBack, !(frontEditable && backEditable) && !photo);
        setHidden(elFontWrap, !anyEditable);
        setHidden(elPhotoWrap, !photo);
        syncRows();
        panel.querySelectorAll('[data-cpe-side]').forEach(function (b) { setClass(b, 'is-active', b.getAttribute('data-cpe-side') === st.side); });

        var b = btnFor(a.id), sh = shapeFor(a.item.shape);
        setText(elName, (sh && sh.label) || (b && b.dataset.title) || '');
        var info = variantInfo[String(a.id)];
        if (info) setText(elPrice, money(info.price));
        else if (b) { var p = b.querySelector('.cp__price'); setText(elPrice, p ? p.textContent.trim() : ''); }

        setClass(panel, 'is-collapsed', collapsed);
        setHidden(editBtn, !collapsed);
        setHidden(elSummary, !collapsed);
        if (collapsed) setText(elSummary, summaryText(a));

        setClass(panel, 'is-invalid', !isValid());
        patchAll();
        updateUrl();
      } finally { syncing = false; }
    }

    function tryCollapse() {
      if (!isValid()) {
        setClass(panel, 'is-invalid', true);
        var first = panel.querySelector('[data-cpe-line="front-0"]');
        if (first) first.focus();
        return false;
      }
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      collapsed = true;
      sync(); reflow();
      var b = btnFor(lastActiveId);
      if (b && b.scrollIntoView) b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }

    panel.addEventListener('input', function (e) {
      var inp = e.target.closest('[data-cpe-line]'); if (!inp) return;
      var parts = inp.getAttribute('data-cpe-line').split('-');
      (parts[0] === 'back' ? st.back : st.front)[Number(parts[1]) || 0] = inp.value;
      st.side = parts[0] === 'back' ? 'back' : 'front';
      sync();
    });

    /* return key on a phone: next open line, or Done on the last one */
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var inp = e.target.closest('[data-cpe-line]'); if (!inp) return;
      e.preventDefault();
      var parts = inp.getAttribute('data-cpe-line').split('-');
      var side = parts[0], idx = Number(parts[1]) || 0;
      if (idx + 1 < shown[side]) {
        var next = panel.querySelector('[data-cpe-line="' + side + '-' + (idx + 1) + '"]');
        if (next) { next.focus(); return; }
      }
      tryCollapse();
    });

    panel.addEventListener('change', function (e) {
      if (e.target.closest('[data-cpe-font]')) { st.font = e.target.value; sync(); return; }
      var r = e.target.closest('input[type="radio"][name^="cpe-type-"]');
      if (r) {
        st.type = r.value === 'photo' ? 'photo' : 'text';
        var a = activeEngrave();
        if (st.type === 'photo' && a && a.item.sides === 2) st.side = 'back';
        if (st.type === 'text') st.side = 'front';
        sync();
      }
    });

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-cpe-done]')) {
        e.preventDefault();
        if (collapsed) { collapsed = false; sync(); reflow(); }
        else tryCollapse();
        return;
      }
      var face = e.target.closest('[data-cpe-face]');
      if (face) { e.preventDefault(); if (!face.hasAttribute('disabled')) switchFaces(Number(face.getAttribute('data-cpe-face')) === 2 ? 2 : 1); return; }
      var add = e.target.closest('[data-cpe-addline]');
      if (add) {
        e.preventDefault();
        var side = add.getAttribute('data-cpe-addline') === 'back' ? 'back' : 'front';
        if (shown[side] < 3) shown[side]++;
        st.side = side; sync();
        var next = panel.querySelector('[data-cpe-line="' + side + '-' + (shown[side] - 1) + '"]');
        if (next) next.focus();
        return;
      }
      var sb = e.target.closest('[data-cpe-side]');
      if (sb) { e.preventDefault(); st.side = sb.getAttribute('data-cpe-side') === 'back' ? 'back' : 'front'; sync(); }
    });

    root.addEventListener('click', function (e) { if (e.target.closest('.cpCollections__summary')) reflow(); }, true);
    root.addEventListener('change', function (e) {
      var n = e.target && e.target.getAttribute && e.target.getAttribute('name');
      if (n && n.indexOf('cpPlacement-') === 0) setTimeout(sync, 0);
    }, true);

    (function applyFromUrl() {
      var raw = null;
      try { raw = new URL(window.location.href).searchParams.get('cp_eng'); } catch (e) {}
      if (!raw) return;
      var s = decodeState(raw); if (!s) return;
      st.type = s.t === 'photo' ? 'photo' : 'text';
      st.font = s.f || st.font;
      st.front = (s.a || []).slice(0, 3); st.back = (s.b || []).slice(0, 3);
      while (st.front.length < 3) st.front.push('');
      while (st.back.length < 3) st.back.push('');
      if (elFont) elFont.value = st.font;
      panel.querySelectorAll('[data-cpe-line]').forEach(function (inp) {
        var parts = inp.getAttribute('data-cpe-line').split('-');
        inp.value = (parts[0] === 'back' ? st.back : st.front)[Number(parts[1]) || 0] || '';
      });
      var radio = panel.querySelector('input[name^="cpe-type-"][value="' + st.type + '"]');
      if (radio) radio.checked = true;
      revealFromValues('front'); revealFromValues('back');
      if (st.type === 'photo') st.side = 'back';
      collapsed = true;
    })();

    (function buildTuner() {
      var on = false;
      try { on = new URL(window.location.href).searchParams.get('cp_tune') === '1'; } catch (e) {}
      if (!on) return;
      var box = panel.querySelector('[data-cpe-tune]'); if (!box) return;
      box.hidden = false;
      var fields = [{ k: 'cx', min: 0, max: 100, step: 0.5 }, { k: 'cy', min: 0, max: 100, step: 0.5 }, { k: 'w', min: 10, max: 100, step: 0.5 }, { k: 'lineGap', min: 0.8, max: 2, step: 0.01 }];
      var touched = {}, ta = document.createElement('textarea');
      function dump() {
        var a = activeEngrave();
        if (!a) { ta.value = 'Select an engravable charm first.'; return; }
        var next = '"' + a.item.shape + '": ' + JSON.stringify((GEOM.byShape || {})[a.item.shape] || {}, null, 2);
        if (ta.value !== next) ta.value = next;
      }
      fields.forEach(function (f) {
        var row = document.createElement('div'); row.className = 'cpe__tuneRow';
        var lab = document.createElement('label'); lab.textContent = f.k;
        var rng = document.createElement('input'); rng.type = 'range'; rng.min = f.min; rng.max = f.max; rng.step = f.step;
        var out = document.createElement('output');
        row.appendChild(lab); row.appendChild(rng); row.appendChild(out); box.appendChild(row);
        f.el = rng; f.out = out;
        rng.addEventListener('input', function () {
          var a = activeEngrave(); if (!a) return;
          touched[f.k] = true; setText(out, rng.value);
          GEOM.byShape = GEOM.byShape || {}; GEOM.byShape[a.item.shape] = GEOM.byShape[a.item.shape] || {};
          GEOM.byShape[a.item.shape][f.k] = Number(rng.value);
          dump(); patchAll();
        });
      });
      ta.className = 'cpe__tuneOut'; ta.readOnly = true; box.appendChild(ta);
      panel.addEventListener('cpe:synced', function () {
        var a = activeEngrave(); if (!a) return;
        var g = geoCurrent(a);
        fields.forEach(function (f) { if (touched[f.k]) return; if (f.el.value !== String(g[f.k])) f.el.value = g[f.k]; setText(f.out, String(g[f.k])); });
        dump();
      });
    })();

    function engravingProps(a) {
      var props = {}, two = a.item.sides === 2, back = nonEmpty(st.back).join(' / ');
      if (st.type === 'photo') {
        props[PROP_PREFIX + ' Type'] = 'Photo';
        props[PROP_PREFIX + ' Front'] = 'Customer artwork, sent by email';
        if (two) { props[PROP_PREFIX + ' Sides'] = back ? 'Front photo + Back text' : 'Front photo'; props[PROP_PREFIX + ' Back'] = back || 'Blank'; if (back) props[PROP_PREFIX + ' Font'] = fontFor(st.font).label; }
        else props[PROP_PREFIX + ' Sides'] = 'Front photo';
        return props;
      }
      props[PROP_PREFIX + ' Type'] = 'Text';
      props[PROP_PREFIX + ' Font'] = fontFor(st.font).label;
      props[PROP_PREFIX + ' Sides'] = two ? 'Front + Back' : 'Front';
      props[PROP_PREFIX + ' Front'] = nonEmpty(st.front).join(' / ');
      if (two) props[PROP_PREFIX + ' Back'] = back || 'Blank';
      return props;
    }

    function openCart() {
      ['cart:refresh', 'cart:open', 'theme:cart:refresh', 'theme:cart:open'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
      var t = document.querySelector('[data-cart-toggle]') || document.querySelector('[data-drawer-toggle="cart"]') || document.querySelector('button[aria-controls*="Cart"]') || document.querySelector('a[href="/cart"]');
      if (t) t.click(); else window.location.href = '/cart';
    }

    function submitDesign(form) {
      var a = activeEngrave();
      if (a && !isValid()) {
        collapsed = false; sync();
        setClass(panel, 'is-invalid', true);
        var first = panel.querySelector('[data-cpe-line="front-0"]');
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (first) first.focus();
        window.alert(COPY.emptyWarning || 'Add at least one line of text.');
        return;
      }
      var idEl = form.querySelector('[name="id"]'), qtyEl = form.querySelector('[name="quantity"]');
      var baseVariantId = Number(idEl && idEl.value || 0);
      var qty = Math.max(1, Number(qtyEl && qtyEl.value || 1));
      if (!baseVariantId) return;
      var titleEl = root.querySelector('[data-charm-title]');
      var m = String(titleEl && titleEl.getAttribute('name') || '').match(/^properties\[(.*)\]$/);
      var propKey = (m && m[1]) ? m[1] : 'Choose charms (optional)';
      var titles = String(titleEl && titleEl.value || '');
      var placement = placementMode();
      var s = slots(); var ids = s.filter(Boolean); if (!ids.length) return;
      var design = designHash(s.join(',') + '|' + placement + '|' + (a ? encodeState(st) : ''));
      var baseProps = {};
      baseProps[propKey] = titles;
      baseProps[propKey + ' - Placement'] = placement === 'tight' ? 'Tight' : 'Standard';
      baseProps['_Design'] = design;
      var items = [{ id: baseVariantId, quantity: qty, properties: baseProps }];
      ids.forEach(function (charmId) {
        var props = { '_Attached to': String(baseVariantId), '_Picker': String(propKey), '_Design': design };
        if (a && Number(charmId) === Number(a.id)) { var extra = engravingProps(a); Object.keys(extra).forEach(function (k) { props[k] = extra[k]; }); }
        items.push({ id: charmId, quantity: qty, properties: props });
      });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) return res.text().then(function (t) { throw new Error(t); }); openCart(); })
        .catch(function (err) { window.alert('Add to cart failed: ' + (err && err.message ? err.message : err)); });
    }

    instances.push({ root: root, panel: panel, sync: sync, hasDesign: function () { return slots().filter(Boolean).length > 0; }, submitDesign: submitDesign });
    sync();
  }

  function initAll() { document.querySelectorAll('[data-charm-picker][data-cp-mode="multi"]').forEach(initRoot); }

  var pending = null, busy = false;
  function schedule() {
    if (busy || pending) return;
    pending = setTimeout(function () {
      pending = null; busy = true;
      try { initAll(); instances.forEach(function (c) { try { c.sync(); c.panel.dispatchEvent(new CustomEvent('cpe:synced')); } catch (e) {} }); }
      finally { busy = false; }
    }, 60);
  }
  function boot() {
    primeShapes(schedule);
    initAll(); schedule();
    new MutationObserver(function () { if (!busy) schedule(); }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if (String(form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    for (var i = 0; i < instances.length; i++) {
      var c = instances[i];
      if (!document.contains(c.root) || !c.hasDesign()) continue;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      c.submitDesign(form);
      return;
    }
  }, true);

})();
